module.exports = __webpack_public_path__ + "media/images/icons/outlined/double-left-384b995d4f6f09e9b2768db615e923ec.svg";